import cn from '@/lib/cn';
import theme from '@/lib/tailwindConfig';

type ColorType = keyof typeof theme.colors;

type ColorMapType = {
    [key in ColorType]?: string;
};

const colorMap: ColorMapType = {
    'analyst-lavender': 'from-analyst-lavender',
    'analyst-lavender-medium': 'from-analyst-lavender-medium',
    'stocktwits-blue': 'from-stocktwits-blue',
    'thematic-blue-lavender': 'from-thematic-blue-lavender',
    'thematic-light-blue': 'from-thematic-light-blue',
    'thematic-light-yellow': 'from-thematic-light-yellow',
    'thematic-neon-yellow': 'from-thematic-neon-yellow',
    'thematic-pink': 'from-thematic-pink',
    'thematic-purple': 'from-thematic-purple',
};

interface CircleBurstProps {
    colorType: ColorType;
    className?: string;
    children?: React.ReactNode;
}

const CircleBurst = ({ colorType, children, className }: CircleBurstProps) => {
    return <div className={cn('bg-radient-circle-c from-0% to-50%', colorMap[colorType], className)}>{children}</div>;
};
export default CircleBurst;
